import { Box, Button, Flex, Link, Text, VStack } from "@chakra-ui/react"
import NextLink from "next/link"
import { useState } from "react"

const ContributorList = ({
  items,
}: {
  items: { name: string; role: string }[]
}) => {
  const [showAll, setShowAll] = useState(false)

  const itemsToShow = showAll ? items : items.slice(0, 1)

  return (
    <Box fontSize={"xs"}>
      <VStack alignItems={"start"}>
        {itemsToShow.map((item, index) => (
          <Flex
            key={index}
            alignItems={"center"}
          >
            <Flex alignItems={"flex-end"}>
              <Link
                as={NextLink}
                href={
                  item.role.toLowerCase() === "author"
                    ? `/a/${encodeURIComponent(item.name)}`
                    : `/s?products[refinementList][${item.role.toLowerCase()}.en_AE][0]=${encodeURIComponent(
                        item.name
                      )}`
                }
                color={"blue.600"}
                maxW={"60vw"}
                textDecoration={"underline"}
                textDecorationStyle={"dashed"}
                textUnderlineOffset={"0.3em"}
                _hover={{
                  textDecoration: "none",
                }}
              >
                <Text
                  isTruncated
                  textOverflow={"ellipsis"}
                >
                  {item.name}
                </Text>
              </Link>
              <Box
                as={"span"}
                ms={2}
              >
                {" "}
                {`(${item.role})`}
              </Box>
            </Flex>
            {items.length > 1 && index === 0 && (
              <Button
                ms={2}
                size={"xs"}
                color={"white"}
                bg={"gray.600"}
                borderRadius={10}
                fontSize={10}
                height={5}
                onClick={() => setShowAll(!showAll)}
                _hover={{
                  bg: "gray.500",
                }}
              >
                {showAll ? "Hide" : "More"}
              </Button>
            )}
          </Flex>
        ))}
      </VStack>
    </Box>
  )
}

export default ContributorList
